<template>
  <BaseSlideOverModal
    v-model:is-modal-open="localOpen"
    width="xl"
    :footer="false"
  >
    <template #body>
      <div class="flex h-full w-full flex-col gap-3">
        <div class="flex border-b">
          <button
            class="px-4 py-2 text-sm font-medium"
            :class="
              activeTab === 'linked'
                ? 'border-primary border-b-2'
                : 'text-gray-500'
            "
            @click="activeTab = 'linked'"
          >
            {{ $t('global.already_linked_items') }}
          </button>

          <button
            class="px-4 py-2 text-sm font-medium"
            :class="
              activeTab === 'all'
                ? 'border-primary border-b-2'
                : 'text-gray-500'
            "
            @click="activeTab = 'all'"
          >
            {{ $t('global.all_items') }}
          </button>
        </div>

        <div class="flex-1 overflow-auto">
          <div v-if="activeTab === 'linked'">
            <template v-if="linkedItems?.length > 0">
              <div v-for="item in linkedItems" :key="item.id" class="my-2">
                <ItemModalCard
                  :item="item"
                  :hide-price="true"
                  :hide-quantity-input="true"
                  :hide-stock-disponibility="true"
                  @selection="selectedItemFromLinked"
                />
              </div>
            </template>
          </div>
          <ListItemChooser
            v-if="activeTab === 'all'"
            :funeral-home-id="invoice.funeral_home_id"
            :item-type-available="'item'"
            :dossier-id="invoice.dossier?.id"
            :can-edit-category="false"
            :already-added-items="[]"
            @selected-item="selectedItem"
          />
        </div>
      </div>
    </template>

    <template #nested-modal>
      <slot name="nested-modal" />
    </template>
  </BaseSlideOverModal>
</template>

<script>
import BaseSlideOverModal from '@c/addf-package/components/modal/BaseSlideOverModal.vue'
import ListItemChooser from '@c/ListItemChooser.vue'
import { mapActions, mapGetters } from 'vuex'
import ItemModalCard from '@ui/modal/item/components/ItemModalCard.vue'
export default {
  name: 'ItemForWikiLinkModal',
  components: { ItemModalCard, BaseSlideOverModal, ListItemChooser },
  props: {
    open: Boolean,
    canEditCategory: Boolean,
    displayPackTab: Boolean,
    hideQuantityInput: Boolean,
    hidePrice: Boolean,
    hideStockDisponibility: Boolean
  },
  emits: ['update:open', 'selected-item', 'item-selected'],
  data() {
    return {
      activeTab: 'linked',
      linkedItems: []
    }
  },
  computed: {
    ...mapGetters({
      invoice: 'invoicing/getInvoice'
    }),
    localOpen: {
      get() {
        return this.open
      },
      set(value) {
        this.$emit('update:open', value)
      }
    }
  },
  watch: {
    localOpen(isOpen) {
      if (isOpen) {
        this.activeTab = 'linked'
      }
    }
  },
  mounted() {
    this.processFetchItemLinkedToWikiAction().then((response) => {
      this.linkedItems = response.items
    })
  },
  methods: {
    ...mapActions({
      processFetchItemLinkedToWikiAction: 'invoicing/fetchItemLinkedToWiki'
    }),
    selectedItem(item) {
      this.$emit('item-selected', item.selectedItem.item)
    },
    selectedItemFromLinked(item) {
      this.$emit('item-selected', item.item)
    }
  }
}
</script>
